(() => {
  const cleanup = () => {
    try {
      if (window.CAJProductCardRotationV3 && typeof window.CAJProductCardRotationV3.destroy === 'function') {
        window.CAJProductCardRotationV3.destroy();
      }
    } catch (error) {}

    try {
      if (window.CAJProductCardRotationV2 && typeof window.CAJProductCardRotationV2.destroy === 'function') {
        window.CAJProductCardRotationV2.destroy();
      }
    } catch (error) {}

    document.querySelectorAll('.caj-gallery-image').forEach((image) => image.remove());
    document.querySelectorAll('.caj-gallery-card, .is-caj-gallery-active').forEach((element) => {
      element.classList.remove('caj-gallery-card', 'is-caj-gallery-active');
    });

    document.querySelectorAll('.product-card-wrapper .card__media .media > img').forEach((image) => {
      image.style.removeProperty('opacity');
      image.style.removeProperty('visibility');
      image.style.removeProperty('display');
    });

    window.CAJProductCardRotationV3 = null;
    window.CAJProductCardRotationV2 = null;
  };

  cleanup();
  document.addEventListener('shopify:section:load', cleanup);
})();
